import { render } from "./Cell.vue?vue&type=template&id=62785473&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=62785473&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62785473"]])

export default __exports__